import React from 'react';
import { Loader, BaasicTable, TableFilter, BaasicConfirmModal, BaasicHeader, BaasicTableExport } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { fileNames } from 'common/constants';
import ReactTooltip from 'react-tooltip';

const ShipmentInfoReturnListTemplate = ({
	t,
	viewStore,
	viewStore: {
		listStore,
		tableData,
		queryUtility,
		loading,
		baasicTableSettingsViewStore,
		columnFilterSetup,
		removeFiltersModal: { removeFiltersConfirm },
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section className="flex--grow--1">
			<BaasicHeader
				title="SHIPMENTSTATUSVIEW.RETURNSHIPMENTS"
				baasicTableSettingsViewStore={baasicTableSettingsViewStore}
			>
				<BaasicTableExport tableViewStore={viewStore} fileTitle={fileNames.shipmentInfoReturn} />
			</BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					viewStore,
				}}
				data={listStore.data.slice()}
				actions={viewStore}
			/>
			<ReactTooltip />
			<TableFilter {...{ viewStore, columnFilterSetup }} />
			<BaasicConfirmModal modalParams={removeFiltersConfirm} />
		</section>
	);
};

export default defaultTemplate(ShipmentInfoReturnListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/shipment-info-return/pages/ShipmentInfoReturnListTemplate.jsx